import { c as _c } from "react/compiler-runtime";
import { FlexCenter, TableHeader, TableHeaderCell, TextBody, TextLabel } from "@opensea/ui-kit";
import { StacksFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { CREATE_OFFER_FLOW_TABLE_CLASSNAMES } from "./constants";
export const CreateOfferFlowTableHeader = t0 => {
  const $ = _c(37);
  const {
    numItems,
    isReview
  } = t0;
  const t = useTranslations("wallet.CreateOfferFlowTableHeader");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StacksFilled size={16} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== numItems || $[2] !== t) {
    t2 = t("itemCount", {
      count: numItems
    });
    $[1] = numItems;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.item}><FlexCenter className="gap-2">{t1}<TextBody className="font-sans lowercase">{t2}</TextBody></FlexCenter></TableHeaderCell>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("floor");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.floor}><TextLabel size="2xs">{t4}</TextLabel></TableHeaderCell>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("topOffer");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}><TextLabel size="2xs">{t6}</TextLabel></TableHeaderCell>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("cost");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.cost}><TextLabel size="2xs">{t8}</TextLabel></TableHeaderCell>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("offerTotal");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}><TextLabel size="2xs">{t10}</TextLabel></TableHeaderCell>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("offeredAt");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.price}><TextLabel size="2xs">{t12}</TextLabel></TableHeaderCell>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== isReview || $[27] !== numItems) {
    t14 = numItems > 1 && !isReview && <TableHeaderCell className={CREATE_OFFER_FLOW_TABLE_CLASSNAMES.remove} />;
    $[26] = isReview;
    $[27] = numItems;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t13 || $[31] !== t14 || $[32] !== t3 || $[33] !== t5 || $[34] !== t7 || $[35] !== t9) {
    t15 = <TableHeader className="h-7 overflow-visible bg-transparent">{t3}{t5}{t7}{t9}{t11}{t13}{t14}</TableHeader>;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
    $[32] = t3;
    $[33] = t5;
    $[34] = t7;
    $[35] = t9;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};